<template>
  <modal :show="visible" @close="visible = false" modalClasses="modal-xxl">
    <div slot="header">
      <h3>Chuyển đơn vị</h3>
    </div>
    <block ref="bmdal" style="min-height: 500px; overflow-y: auto;">
      <div v-if="productInfo.product && productInfo.productSpecify" class="legend">
        <div class="title">
          Thông tin sản phẩm
        </div>
        <div class="row">
          <div class="col-6">
            <ul>
              <li>
                Tên sản phẩm: <b>{{ productInfo.product.name }}</b>
              </li>
              <li>
                Mã sản phẩm: <b>{{ productInfo.product.code }}</b>
              </li>
              <li>
                Quy cách: <b>{{ productInfo.productSpecify.name }}</b> mm
              </li>
              <li>
                Hệ màu: <b>{{ productInfo.color.label }}</b>
              </li>
            </ul>
          </div>
          <div class="col-6">
            <ul>
              <li>
                Mã màu 1: <b>{{ productInfo.colorCode1 }}</b>
              </li>
              <li>
                Mã màu 2: <b>{{ productInfo.colorCode2 }}</b>
              </li>
              <li>
                Độ dài: <b>{{ productInfo.length }}</b> cm
              </li>
              <li>Vị trí lưu kho: <span v-html="productInfo.position"></span></li>
            </ul>
          </div>
        </div>
      </div>
      <div style="font-size: 24px; padding: 14px 0;">
        Số lượng tồn : <b>{{ productInfo.quantity }}</b> {{ productInfo.unit }}
      </div>
      <ValidationObserver ref="csInfo" v-slot="{ handleSubmit }">
        <form role="form" @submit.prevent="handleSubmit">
          <div style="box-shadow: 1px 1px 1px 1px #000; padding:15px; padding-top: 25px; position: relative; margin-top: 20px;">
            <div style="position: absolute; left: 20px; top: -16px; background: #fff; padding: 2px 24px;border: 1px solid #c2c2c2;">
              Bạn muốn chuyển
            </div>
            <div class="row">
              <div class="col-2">
                <base-input label="Số lượng" v-model="oldQuantity"> </base-input>
              </div>
              <div class="col-2">
                <ValidationProvider name="Đơn vị tính" rules="required" v-slot="{ errors }">
                  <base-select
                    v-model="productInfo.unit"
                    :options="['M', 'Yard', 'Kg', 'Sợi']"
                    label="Đơn vị "
                    :disabled="true"
                    :error="errors[0]"
                  ></base-select>
                </ValidationProvider>
              </div>
              <div class="col-2">
                <div style="padding: 15px;text-align: center;">
                  <span>Thành</span> <br />
                  <i class="fa fa-arrow-right"></i>
                </div>
              </div>
              <div class="col-2">
                <base-input label="Số lượng" v-model="newQuantity"> </base-input>
              </div>
              <div class="col-2">
                <ValidationProvider name="Đơn vị tính" rules="required" v-slot="{ errors }">
                  <base-select v-model="newUnit" :options="listUnit" label="Đơn vị " :error="errors[0]"></base-select>
                </ValidationProvider>
              </div>
            </div>
          </div>
        </form>
        <hr />
        <button type="button" @click="handleClose" class="btn btn-secondary">
          Đóng
        </button>
        <button type="submit" @click="doSave(0)" class="btn btn-dark">
          Lưu đóng (F4)
        </button>
      </ValidationObserver>
    </block>
    <event @doSave="doSave(0)" @doCancel="handleClose"></event>
  </modal>
</template>
<script>
import { productService } from '@/_services';

export default {
  props: {},
  components: {},
  data() {
    return {
      visible: false,
      productInfo: {
        id: 0,
        color: {},
        productSpecify: {},
        unit: '',
        product: {},
        colorCode1: '',
        colorCode2: '',
        colorText: '',
        length: 0,
        quota: 0,
        quantity: 0,
        totalKgWrap: 0,
        position: '',
        description: ''
      },
      newUnit: '',
      oldQuantity: 0,
      newQuantity: 0,
      listUnit: []
    };
  },
  methods: {
    setData(productInfo) {
      this.productInfo = productInfo;
      this.listUnit = [];
      ['M', 'Yard', 'Kg', 'Sợi'].forEach(element => {
        if (element != productInfo.unit) {
          this.listUnit.push(element);
        }
      });
      this.oldQuantity = this.productInfo.quantity;
    },
    doSave: function(type) {
      var self = this;
      debugger;
      if (!this.visible) return;

      if (this.oldQuantity > this.productInfo.quantity) {
        this.$alertify.error('Số lượng chuyển đổi không được lớn hơn số lượng tồn');
        return;
      }

      if (this.newUnit == '') {
        this.$alertify.error('Vui lòng chọn đơn vị muốn chuyển đổi');
        return;
      }

      if (this.newQuantity == 0) {
        this.$alertify.error('Số lượng mới đang = 0');
        return;
      }

      this.$refs.csInfo.validate().then(success => {
        if (!success) return;

        self
          .$swal({
            title: 'Bạn có chắc muốn thực hiện chuyển đổi',
            text: `Bạn đang thực hiện chuyển đổi sản phẩm từ '${self.oldQuantity} ${self.productInfo.unit}' thành '${self.newQuantity} ${self.newUnit}'`,
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'OK',
            cancelButtonText: 'Không',
            reverseButtons: true
          })
          .then(function(result) {
            if (result.value) {
              self.$refs.bmdal.block();
              productService
                .saveConverUnitProductInfo(self.productInfo, self.oldQuantity, self.newQuantity, self.newUnit)
                .then(res => {
                  self.$emit('reloadProductInfo');
                  self.$alertify.success(res.message, {
                    duration: 4000
                  });
                })
                .catch(err => {
                  if (err.data) {
                    err.data.forEach(element => {
                      let errObj = {};
                      errObj[element.context.key] = [element.message];
                      self.$refs.csInfo.setErrors(errObj);
                    });
                  }
                })
                .finally(() => {
                  if (type == 0) {
                    self.visible = false;
                  }
                  self.$refs.bmdal.unBlock();
                });
            }
          });
      });
    },
    handleClose() {
      this.visible = false;
    }
  }
};
</script>
